Agan = Agan || {};

Agan.initDetailsEvents = function () {
    var $oDetailsWrapper = $('#details'), $oReviewRating = $('#reviewRating'),
        $oMorePicsSlider = $('#morePicsContainer');

    if ($oReviewRating.length) {
        var $oRatingForm = $('#rating');

        $oReviewRating.find('.ox-write-review').on('click mouseenter touch', function () {
            var $this = $(this), $oParent = $this.parent();
            $oParent.prevAll().find('i').removeClass('fa-star-o').addClass('fa-star');
            $oParent.nextAll().find('i').removeClass('fa-star').addClass('fa-star-o');
            $this.find('i').removeClass('fa-star-o').addClass('fa-star');

            $oRatingForm.find('#recommListRating, #productRating').val($oParent.attr('data-rate-value'));
        });
    }

    $('#zoom1').click(function (e) {
        e.preventDefault();
        var iIndex = 0;

        if ($oMorePicsSlider.length) {
            iIndex = $oMorePicsSlider.find('a.selected').data('num') - 1;
        }
    });

    if ($oMorePicsSlider.length) {
        $oMorePicsSlider.find('a').click(function (e) {
            e.preventDefault();
            var $this = $(this);
            $('#zoom1').attr('href', $this.data('zoom-url')).find('img').attr('src', this.href);
            $oMorePicsSlider.find('a.selected').removeClass('selected');
            $this.addClass('selected');
        });
    }
};

/** gallery image zoom */
function initZoom() {
    if ($('img#oxImageZoom').length > 0) {

        var image = $('#morePicsContainer a'), zoomImage = $('img#oxImageZoom'), zoomConfig = {
            zoomType: 'inner',
            cursor: 'zoom-out',
            responsive: true,
            easing: 'true',
            zoomWindowFadeIn: 200,
            zoomWindowFadeOut: 400
        };

        $(zoomImage).click(function () {

            if ($('.zoom-enabled').length === 0) {
                zoomImage.elevateZoom(zoomConfig);
                $(this).toggleClass('zoom-enabled');
                $('.zoomContainer').show();
            } else {
                $(this).toggleClass('zoom-enabled');
                $('.zoomContainer').hide();
            }
        });

        image.click(function () {
            $('.zoomContainer').remove();
            zoomImage.removeData('elevateZoom');
            zoomImage.data('zoom-image', $(this).data('zoom-url'));
            if ($('.zoom-enabled').length !== 0) {
                $(zoomImage).toggleClass('zoom-enabled');
            }
        });
    }
}

/** initialize mobile gallery */
function initMobileGallery() {

    return new responsiveSwiper({
        element: '.picture-gallery-wrapper--mobile .swiper-container.hasSwiper', breakPoint: 767, swiperOptions: {
            loop: true, preloadImages: false, lazyLoading: true, pagination: {
                el: '.swiper-pagination', clickable: true
            }
        }
    });
}

function initArticleVariantClickListener() {
    let conditionsArray = document.querySelectorAll('.conditions-condition');
    conditionsArray.forEach((condition) => {
        condition.addEventListener('click', (e) => {
            if (!e.target.classList.contains("prebook-now")) {
                const index = Array.from(condition.parentNode.children).indexOf((condition));
                let conditionLink = conditionsArray[index - 2].getAttribute('data-article-link');
                window.location.replace(conditionLink);
            }
        });
    });
}

/** mobile/desktop accordion */
function initTabsDesktopAndMobile() {
    if ($('.tabbed-content').length > 0) {
        var $tabs = $('.tabbed-content');
        $tabs.aganMobileAccordion({});

        // open tab and jump to reviews
        $('a#goto-review').on('click tap', function (event) {
            $tabs.data('plugin_aganMobileAccordion').toggleTab('#ratings', event, true);
        });

        // check if we need to open a specific tab
        if (window.location.hash) {
            $tabs.data('plugin_aganMobileAccordion').toggleTab(window.location.hash);
        }
    }
}

/** show more, on product details page */
function initShowMoreInformation(selector) {
    $(selector).each(function () {
        var $wrap = $(this);
        if ($wrap.data('showmore-init')) return;
        $wrap.data('showmore-init', 1);

        var $content = $wrap.find('.showMore-content').first();
        var $btn = $wrap.find('.showMore-button').first();
        var collapsed = parseInt($wrap.data('collapsed-height'), 10) || 200;

        $wrap.removeClass('showMore--expand').attr('aria-expanded', 'false');
        if ($content[0]) $content[0].style.maxHeight = collapsed + 'px';
        $btn.hide();

        function needCollapse() {
            var el = $content[0];
            return !!el && el.scrollHeight > collapsed + 1;
        }

        function syncState() {
            if (!$wrap.is(':visible') || !$wrap[0].getClientRects().length) return;

            if (!needCollapse()) {
                $wrap.removeClass('showMore--collapsible').addClass('showMore--noButton');
                if ($content[0]) $content[0].style.maxHeight = 'none';
                $btn.hide();
                $wrap.attr('aria-expanded', 'false');
                return;
            }

            $wrap.addClass('showMore--collapsible').removeClass('showMore--noButton');
            $btn.show();

            if ($wrap.hasClass('showMore--expand')) {
                $content[0].style.maxHeight = $content[0].scrollHeight + 'px';
            } else {
                $content[0].style.maxHeight = collapsed + 'px';
            }
        }

        $btn.off('click.showMore').on('click.showMore', function () {
            var isOpen = $wrap.hasClass('showMore--expand');

            if (isOpen) {
                $wrap.removeClass('showMore--expand').attr('aria-expanded', 'false');
                $content[0].style.maxHeight = collapsed + 'px';

                var targetSel = $wrap.data('scroll-target');
                var targetEl = targetSel ? document.querySelector(targetSel) : $wrap[0];
                if (targetEl && targetEl.scrollIntoView) {
                    var behavior = $wrap.data('scroll-behavior') || 'instant';
                    targetEl.scrollIntoView({behavior: behavior, block: 'start'});
                }
            } else {
                $wrap.addClass('showMore--expand').attr('aria-expanded', 'true');
                $content[0].style.maxHeight = $content[0].scrollHeight + 'px';
            }
        });

        function whenVisible(cb, tries) {
            tries = tries || 0;
            var visible = $wrap.is(':visible') && $wrap[0].getClientRects().length > 0;
            if (visible) return cb();
            if (tries < 50) setTimeout(function () {
                whenVisible(cb, tries + 1);
            }, 100);
        }

        $(document).on('shown.bs.tab.showMore shown.aganTab.showMore', function () {
            whenVisible(syncState);
        });

        if (window.MutationObserver && $content[0]) {
            var mo = new MutationObserver(syncState);
            mo.observe($content[0], {childList: true, subtree: true, characterData: true});
        }

        window.addEventListener('orientationchange', syncState);
        window.addEventListener('pageshow', function (e) {
            if (e.persisted) syncState();
        });

        whenVisible(syncState);
        setTimeout(syncState, 0);
        setTimeout(syncState, 200);
        setTimeout(syncState, 600);
    });
}

function initShowMoreJumpLinks() {
    $('.showMore-jump').off('click.showMoreJump').on('click.showMoreJump', function (e) {
        e.preventDefault();
        var $link = $(this);

        var targetSelector = $link.data('showmore-target');
        var $wrap = targetSelector ? $(targetSelector) : $link.closest('.showMore');

        if (!$wrap.length) return;

        var anchorSelector = $link.attr('href') || $link.data('showmore-anchor');
        var $anchor = anchorSelector ? $(anchorSelector) : $wrap;

        if (!$anchor.length) return;

        var scrollToAnchor = function () {
            var el = $anchor[0];
            if (el && el.scrollIntoView) {
                el.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        };

        if (!$wrap.hasClass('showMore--expand')) {
            var $btn = $wrap.find('.showMore-button').first();
            if ($btn.length) {
                $btn.trigger('click');

                setTimeout(scrollToAnchor, 320);
            } else {
                scrollToAnchor();
            }
        } else {
            scrollToAnchor();
        }
    });
}

/** Image loading with blured smaller Image */
function blurLoadingImage() {
    $('.blurLoad').each(function () {
        var $this = $(this), src = $(this).data('src');
        $this.attr('src', src);
    });
}

/** PDP Voucher Countdown */

/* temporär ausgebaut DEV-1855
function setVoucherCountdown() {
    var vouchercounter = $(".voucher--coupon--countdown");

    if (vouchercounter.length > 0) {
        setInterval(function () {
            var toDate = new Date();
            var tomorrow = new Date();
            tomorrow.setHours(24, 0, 0, 0);
            var diffMS = tomorrow.getTime() / 1000 - toDate.getTime() / 1000;
            var diffHr = Math.floor(diffMS / 3600);
            diffMS = diffMS - diffHr * 3600;
            var diffMi = Math.floor(diffMS / 60);
            diffMS = diffMS - diffMi * 60;
            var diffS = Math.floor(diffMS);
            var result = ((diffHr < 10) ? "0" + diffHr : diffHr);
            result += ":" + ((diffMi < 10) ? "0" + diffMi : diffMi);
            result += ":" + ((diffS < 10) ? "0" + diffS : diffS);

            for (let i = 0; i < vouchercounter.length; i++) {
                vouchercounter[i].innerHTML = result;
            }
        }, 1000);
    }
}
*/

function initPdpSeriesScrollRestore() {
    if (window.innerWidth > 786) return;

    const KEY = 'pdpSeriesScroll';

    try {
        const raw = sessionStorage.getItem(KEY);
        if (raw) {
            const data = JSON.parse(raw);
            sessionStorage.removeItem(KEY);

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (data.anchorId) {
                        const el = document.getElementById(data.anchorId);
                        if (el) el.scrollIntoView({block: 'start'});
                    } else if (typeof data.scrollY === 'number') {
                        window.scrollTo(0, data.scrollY);
                    }
                });
            });
        }
    } catch (e) {
    }

    document.addEventListener('click', (e) => {
        const link = e.target.closest('#groupSeries a.pdp-variants__tile, #groupSeries a.pdp-variants__swatch');
        if (!link) return;

        const href = link.getAttribute('href') || '';
        if (!href || href === '#' || link.classList.contains('is-disabled') || link.classList.contains('is-active')) {
            return;
        }

        const group = link.closest('.pdp-variants__group');
        const anchorId = group && group.id ? group.id : '';

        try {
            sessionStorage.setItem(KEY, JSON.stringify({
                scrollY: window.scrollY, anchorId: anchorId
            }));
        } catch (error) {
        }
    }, {capture: true});
}

function sortColorSwatchesAlphabetically(root = document) {
    const container = root.querySelector('.pdp-variants__swatches');
    if (!container) return;

    const items = Array.from(container.querySelectorAll('a.pdp-variants__swatch[data-color-label]'));
    if (!items.length) return;

    const collator = new Intl.Collator(document.documentElement.lang || 'de', {
        sensitivity: 'base', numeric: true
    });

    items.sort((a, b) => {
        const al = (a.dataset.colorLabel || '').trim();
        const bl = (b.dataset.colorLabel || '').trim();
        return collator.compare(al, bl);
    });

    for (const el of items) container.appendChild(el);
}

function setColorSwatches() {
    var MAP_BASE_URL = '/out/agan/src/js/';
    var STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

    var toneToHex = {
        beige: '#d7c3a3',
        blau: '#4867cf',
        braun: '#8a5a2b',
        gelb: '#f0c419',
        gold: '#d4b56a',
        grau: '#9aa0a6',
        gruen: '#248750',
        kupfer: '#b87333',
        lime: '#BFFF00',
        mint: '#3EB489',
        orange: '#f39c12',
        pink: '#d674a0',
        rosa: '#E887B7',
        rot: '#d12c2c',
        schwarz: '#1a1a1a',
        silber: '#bfc1c2',
        sonstige: '#cccccc',
        titan: '#878681',
        violett: '#7b67d6',
        weiss: '#f5f5f5'
    };

    function getLang() {
        var lang = (document.documentElement.lang || '').toLowerCase();

        if (lang.indexOf('de') === 0) return 'de';
        if (lang.indexOf('es') === 0) return 'es';
        if (lang.indexOf('fr') === 0) return 'fr';
        if (lang.indexOf('it') === 0) return 'it';

        var path = window.location.pathname.toLowerCase();

        if (path.indexOf('/es/') === 0) return 'es';
        if (path.indexOf('/fr/') === 0) return 'fr';
        if (path.indexOf('/it/') === 0) return 'it';

        return 'de';
    }

    function getMapUrl(lang) {
        return MAP_BASE_URL + 'colorToneMap.' + lang + '.json';
    }

    function getStorageKey(lang) {
        return 'aganColorToneMap:' + lang + ':v2';
    }

    function norm(s) {
        return (s || '')
            .toLowerCase()
            .replace(/\u00a0/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .replace(/ä/g, 'ae')
            .replace(/ö/g, 'oe')
            .replace(/ü/g, 'ue')
            .replace(/ß/g, 'ss');
    }

    function safeTone(s) {
        return String(s || '')
            .toLowerCase()
            .replace(/[^a-z0-9-]/g, '');
    }

    function isDark(hex) {
        if (!hex || hex[0] !== '#' || hex.length !== 7) return false;

        var r = parseInt(hex.substr(1, 2), 16);
        var g = parseInt(hex.substr(3, 2), 16);
        var b = parseInt(hex.substr(5, 2), 16);
        var lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

        return lum < 0.35;
    }

    /** Setry reporting for missing color match */
    function reportMissingColorMapping(data) {
        console.log("no color mapping for", data);
        fetch('/ajax/pdp-color-mapping', {
            method: 'POST', headers: {
                'Content-Type': 'application/json'
            }, credentials: 'same-origin', body: JSON.stringify(data), keepalive: true
        }).catch(function () {
            // Reporting has no affect on pdp
        });
    }

    function apply(map) {
        var nodes = document.querySelectorAll('[data-color-label]');

        for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            var labelRaw = el.getAttribute('data-color-label');
            var label = norm(labelRaw);

            // check if mapping exists
            var hasMapping = map && Object.prototype.hasOwnProperty.call(map, label);

            // report missing mapping
            if (!hasMapping) {
                reportMissingColorMapping({
                    color: labelRaw,
                    normalizedColor: label,
                    language: getLang(),
                    productTitle: document.querySelector('#productTitle') ? document.querySelector('#productTitle').textContent.trim() : null,
                    pathname: window.location.pathname
                });
            }

            var tone = hasMapping ? map[label] : 'sonstige';
            tone = safeTone(tone);

            el.classList.add('tone-' + tone);

            var hex = toneToHex[tone] || toneToHex.sonstige;
            var dot = el.querySelector('.pdp-variants__dot');
            var target = dot || el;

            target.style.backgroundColor = hex;

            if (tone === 'weiss' || tone === 'silber' || tone === 'titan' || tone === 'beige' || tone === 'sonstige') {
                target.style.border = '1px solid rgba(0,0,0,.18)';
            } else if (isDark(hex)) {
                target.style.border = '1px solid rgba(255,255,255,.35)';
            } else {
                target.style.border = '1px solid rgba(0,0,0,.12)';
            }
        }
    }

    function loadFromStorage(key) {
        try {
            var raw = localStorage.getItem(key);
            if (!raw) return null;

            var parsed = JSON.parse(raw);
            if (!parsed || !parsed.ts || !parsed.map) return null;
            if ((Date.now() - parsed.ts) > STORAGE_TTL_MS) return null;

            return parsed.map;
        } catch (e) {
            return null;
        }
    }

    function saveToStorage(key, map) {
        try {
            localStorage.setItem(key, JSON.stringify({
                ts: Date.now(), map: map
            }));
        } catch (e) {
        }
    }

    function fetchMap(lang) {
        return fetch(getMapUrl(lang), {cache: 'force-cache'}).then(function (r) {
            if (!r.ok) throw new Error('ColorToneMap not found: ' + lang);
            return r.json();
        });
    }

    function boot() {
        var lang = getLang();
        var storageKey = getStorageKey(lang);

        var cached = loadFromStorage(storageKey);

        if (cached) {
            apply(cached);
            return;
        }

        fetchMap(lang)
            .then(function (map) {
                saveToStorage(storageKey, map);
                apply(map);
            })
            .catch(function () {
                // Fallback auf DE, falls Sprach-JSON fehlt
                var fallbackKey = getStorageKey('de');
                var cachedDe = loadFromStorage(fallbackKey);

                if (cachedDe) {
                    apply(cachedDe);
                    return;
                }

                fetchMap('de')
                    .then(function (map) {
                        saveToStorage(fallbackKey, map);
                        apply(map);
                    })
                    .catch(function () {
                        apply(null);
                    });
            });
    }

    boot();
    sortColorSwatchesAlphabetically();
    initPdpSeriesScrollRestore();
}

function parsePriceDiff(text) {
    if (!text) return 0;

    let normalized = text
        .replace(/\s+/g, '')
        .replace('€', '')
        .replace(',-', '')
        .replace(',', '.');

    const match = normalized.match(/[+-]?\d+(\.\d+)?/);
    if (!match) return 0;

    return parseFloat(match[0]);
}

function hideColorDiffsIfAllZero() {
    const swatches = document.querySelectorAll('.pdp-variants__swatch');
    if (!swatches.length) return;

    const diffEls = Array.from(document.querySelectorAll('.pdp-variants__swatch .pdp-variants__price-diff'));

    if (!diffEls.length) return;

    const priceValues = diffEls
        .filter(el => !el.querySelector('.fa-check'))
        .map(el => el.textContent.trim())
        .filter(text => text)
        .map(parsePriceDiff);

    if (!priceValues.length) return;

    const allZero = priceValues.every(val => val === 0);

    if (allZero) {
        diffEls.forEach(el => {
            if (!el.querySelector('.fa-check')) {
                el.style.display = 'none';
            }
        });
    }
}

function focusForConditions() {
    document.querySelectorAll('.conditions').forEach((group) => {
        const items = Array.from(group.querySelectorAll('.conditions-condition'));

        if (!items.length) return;

        let currentIndex = items.findIndex((item) => item.classList.contains('condition--selected'));

        if (currentIndex < 0) currentIndex = 0;

        items.forEach((item, index) => {
            item.setAttribute('tabindex', index === currentIndex ? '0' : '-1');
        });

        function moveFocus(newIndex) {
            if (newIndex < 0 || newIndex >= items.length) return;

            items[currentIndex].setAttribute('tabindex', '-1');
            items[newIndex].setAttribute('tabindex', '0');
            items[newIndex].focus();

            currentIndex = newIndex;
        }

        items.forEach((item, index) => {
            item.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                    e.preventDefault();
                    moveFocus((index + 1) % items.length);
                }

                if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                    e.preventDefault();
                    moveFocus((index - 1 + items.length) % items.length);
                }

                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    const link = item.dataset.articleLink;
                    if (link) {
                        window.location.href = link;
                    }
                }
            });
        });
    });
}

const STORAGE_ATTRIBUTE_IDS = ['agan_pattribut_speicherkapazitaet', 'agan_pattribut_festplattenkapazitaet', 'agan_pattribut_ram_speicher'];

function parseStorageValue(value) {
    if (!value) return Number.MAX_SAFE_INTEGER;

    const text = String(value)
        .toLowerCase()
        .replace(/\u00a0/g, ' ')
        .replace(',', '.')
        .trim();

    const match = text.match(/(\d+(?:\.\d+)?)\s*(tb|gb|mb|mo|go|to)/i);

    if (!match) return Number.MAX_SAFE_INTEGER;

    const number = parseFloat(match[1]);
    const unit = match[2].toLowerCase();

    if (unit === 'tb') return number * 1024 * 1024;
    if (unit === 'gb') return number * 1024;
    if (unit === 'mb') return number;

    return Number.MAX_SAFE_INTEGER;
}

function sortStorageVariantButtons(root = document) {
    STORAGE_ATTRIBUTE_IDS.forEach(attributeId => {
        const grids = root.querySelectorAll(`[data-variant-attribute-title="${attributeId}"]`);

        grids.forEach(grid => {
            const items = Array.from(grid.querySelectorAll('.pdp-variants__tile'));

            items.sort((a, b) => {
                const aValue = a.dataset.variantValue || a.textContent.trim();
                const bValue = b.dataset.variantValue || b.textContent.trim();

                const aSort = parseStorageValue(aValue);
                const bSort = parseStorageValue(bValue);

                if (aSort !== bSort) return aSort - bSort;

                return aValue.localeCompare(bValue, 'de', {
                    numeric: true, sensitivity: 'base'
                });
            });

            items.forEach(item => grid.appendChild(item));
        });
    });
}

$(document).ready(function () {
    blurLoadingImage();
    // setVoucherCountdown();

    if ($('.cl-details').length) {
        if (!window.isMobileDevice()) {
            Agan.initDetailsEvents();
        }

        initZoom();
        initMobileGallery();
        initArticleVariantClickListener();
        initTabsDesktopAndMobile();
        initShowMoreInformation('.showMore');
        initShowMoreJumpLinks();
        sortStorageVariantButtons();
        hideColorDiffsIfAllZero();
        setColorSwatches();
        focusForConditions();
    }
});

function toggleVideo() {
    var x = document.getElementById("videoselectbox");
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}
